import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IItemAssigmentLogResponse {
  _id: string;
  userId: string;
  assignId: string;
  stepId?: string;
  assignName: string;
  userName: string;
  preSignedUrl: string;
  message: string;
  timeOut: number;
  createAt?: Date;
}

export interface AccountState {
  loading: boolean;
  isDeleting: boolean;
  isAdding: boolean;
  accounts: any[];
}

const initialState: AccountState = {
  loading: false,
  isDeleting: true,
  isAdding: true,
  accounts: [],
};

export const accountSlice = createSlice({
  name: "accont",
  initialState,
  reducers: {
    getAccounts: (state, action) => {
      state.loading = true;
    },
    getAccountsSuccess: (state, action) => {
      state.loading = false;
      state.accounts = action.payload.accounts;
    },
    getAccountFaild: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.accounts = [];
    },
    addAccount: (state, action) => {
      state.isAdding = true;
    },
    addAccountSuccess: (state, action) => {
      state.isAdding = false;
    },
    addAccountFaild: (state, action: PayloadAction<string>) => {
      state.isAdding = false;
    },
    updateAccount: (state, action) => {
      state.loading = true;
    },
    updateAccountSuccess: (state, action) => {
      state.loading = false;
    },
    updateAccountFaild: (state, action: PayloadAction<string>) => {
      state.loading = false;
    },
    deleteAccount: (state, action) => {
      state.loading = true;
      state.isDeleting = true;
    },
    deleteAccountSuccess: (state, action) => {
      state.loading = false;
      state.isDeleting = false;
    },
    deleteAccountFaild: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.isDeleting = false;
    },
    decodePassword: (state, action) => {
      state.loading = true;
    },
    decodePasswordSuccess: (state, action) => {
      state.loading = false;
    },
    decodePasswordFaild: (state, action: PayloadAction<string>) => {
      state.loading = false;
    },
  },
});

export const {
  getAccounts,
  getAccountsSuccess,
  getAccountFaild,
  addAccount,
  addAccountSuccess,
  addAccountFaild,
  updateAccount,
  updateAccountSuccess,
  updateAccountFaild,
  deleteAccount,
  deleteAccountSuccess,
  deleteAccountFaild,
  decodePassword,
  decodePasswordSuccess,
  decodePasswordFaild
} = accountSlice.actions;

export default accountSlice.reducer;
